module.exports = __webpack_public_path__ + "static/media/calendarRemove.b73bf306.svg";